module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gZ0uT"))).then(() => parcelRequire('10L3v'));